class ProductQuantitySelector extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[name="quantity"]');
    this.decrementBtn = this.querySelector(".product-details__decrement");
    this.incrementBtn = this.querySelector(".product-details__increment");

    if (!this.input || !this.decrementBtn || !this.incrementBtn) return;

    this.decrementBtn.addEventListener(
      "click",
      this.#handleDecrement.bind(this)
    );
    this.incrementBtn.addEventListener(
      "click",
      this.#handleIncrement.bind(this)
    );
  }

  #handleDecrement() {
    const value = parseInt(this.input.value, 10) || 1;
    const min = parseInt(this.input.getAttribute("min"), 10) || 1;
    if (value > min) {
      this.input.value = value - 1;
      this.input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  #handleIncrement() {
    const value = parseInt(this.input.value, 10) || 1;
    const max = parseInt(this.input.getAttribute("max"), 10) || 1;
    if (value < max) {
      this.input.value = value + 1;
      this.input.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }
}

if (!customElements.get("product-quantity-selector")) {
  customElements.define("product-quantity-selector", ProductQuantitySelector);
}
